<template>
	<div class="modal-prices">

    <div class="modal fade" id="modalPrices" tabindex="-1" role="dialog" aria-labelledby="modalPricesLabel" aria-hidden="true">
      <div class="modal-dialog modal-prices" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalPricesLabel">Listado de precios</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body table-responsive">
            <table-products :contract="contract" v-if="contract != null"/>
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalPrices" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import TableProducts from './../table-products/table-products.vue'
export default {
	name: 'ModalPrices',
	props: ['contract'],
	data() {
		return {

		}
	},  
	methods: {

	},
	created () {
    
	},
  components: {
    'table-products': TableProducts,
  }
}
</script>
<style scoped>
  .modal-prices{
    width: 90%;
  }
</style>